// services/breadcrumbService.js
import api from './api';

class BreadcrumbService {
    static CACHE_KEY = 'breadcrumbData';
    static CACHE_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds

    static async getBreadcrumbData(forceRefresh = false) {
        try {
            // Check localStorage first, unless forceRefresh is true
            if (!forceRefresh) {
                const cachedData = this.getCachedData();
                if (cachedData) {
                    return cachedData;
                }
            } else {
                this.clearCache();
            }

            // If no cached data or forceRefresh, fetch from API
            const response = await api.get('/api/breadcrumb-data/');
            const data = response.data;

            // Cache the data
            this.cacheData(data);

            return data;
        } catch (error) {
            console.error('Error fetching breadcrumb data:', error);
            throw error;
        }
    }

    static getCachedData() {
        const cachedItem = localStorage.getItem(this.CACHE_KEY);
        if (!cachedItem) return null;

        try {
            const { data, timestamp } = JSON.parse(cachedItem);
            // Check if cache is expired
            if (Date.now() - timestamp > this.CACHE_DURATION) {
                localStorage.removeItem(this.CACHE_KEY);
                return null;
            }
            return data;
        } catch {
            localStorage.removeItem(this.CACHE_KEY);
            return null;
        }
    }

    static cacheData(data) {
        const cacheItem = {
            data,
            timestamp: Date.now()
        };
        localStorage.setItem(this.CACHE_KEY, JSON.stringify(cacheItem));
    }

    static clearCache() {
        localStorage.removeItem(this.CACHE_KEY);
    }
}

export default BreadcrumbService;